import { environment } from '@environments/environment'
import type * as CSS from 'csstype'
import { keys, reduce } from 'lodash-es'
import { objectToString } from '@utils/object-to-string'

type TLogStyle = 'default' | 'warn' | 'error';

const bullet = '\u2022'

const nameStyleMap: { [K in TLogStyle]: string[] } = {
  default: null,
  warn: ['warn'],
  error: ['error'],
}

const baseStyle: CSS.Properties = {
  borderRadius: '5px',
  padding: '3px 7px',
}

const rawStyles: { [K in TLogStyle]: CSS.Properties } = {
  default: {
    backgroundColor: '#000',
    color: '#6CC417',
    ...baseStyle,
  },
  warn: {
    backgroundColor: '#FEC106',
    color: '#000',
    ...baseStyle,
  },
  error: {
    backgroundColor: '#DC3545',
    color: '#FFF',
    ...baseStyle,
  },
}

const loggerStyles: { [K in TLogStyle]: string } = reduce(
  rawStyles,
  (acc: any, value: CSS.Properties, key: string) => {
    acc[key] = objectToString(value)
    return acc
  },
  {},
)

export const logger = (name: string, ...args: any[]) => {
  if (environment.loggers.includes(name)) {
    let style: TLogStyle = 'default'
    for (const key of keys(nameStyleMap)) {
      const names: string[] = nameStyleMap[key as TLogStyle]
      if (names?.includes(name)) style = key as TLogStyle
    }

    const isJest = !!(window as any)?.isJest
    if (!isJest) {
      if (args.length === 1 && typeof args[0] === 'string') {
        console.log(`%c${name} ${bullet}${bullet} ${args[0]}`, loggerStyles[style])
      } else {
        console.log(`%c${name}`, loggerStyles[style], ...args)
      }
    }
  }
}
